/** QR payload parsing (ADR-009, F-06). Printed codes are production URLs; typing still works. */

export type QrScan =
  | { kind: 'tote'; number: string }
  | { kind: 'asset'; serial: string }
  | { kind: 'slug'; slug: string }
  | { kind: 'typed'; value: string };

function decodeSegment(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function pathFromPayload(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('/')) {
    return trimmed.split(/[?#]/)[0] ?? trimmed;
  }
  const withoutScheme = trimmed.replace(/^https?:\/\//i, '');
  const slash = withoutScheme.indexOf('/');
  if (slash === -1) return null;
  return withoutScheme.slice(slash).split(/[?#]/)[0] ?? null;
}

export function parseQrPayload(raw: string): QrScan | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const path = pathFromPayload(trimmed);
  if (path) {
    const parts = path.split('/').filter((part) => part.length > 0);
    const head = parts[0]?.toLowerCase();
    const rest = parts.slice(1).join('/');
    const value = rest ? decodeSegment(rest) : '';
    if (head === 't' && value) return { kind: 'tote', number: value };
    if (head === 'a' && value) return { kind: 'asset', serial: value };
    if (head === 'q' && value) return { kind: 'slug', slug: value };
  }

  return { kind: 'typed', value: trimmed };
}

export function qrScanPath(scan: QrScan): string {
  switch (scan.kind) {
    case 'tote':
      return `/t/${encodeURIComponent(scan.number)}`;
    case 'asset':
      return `/a/${encodeURIComponent(scan.serial)}`;
    case 'slug':
      return `/q/${encodeURIComponent(scan.slug)}`;
    case 'typed':
      return `/inventory/new?tote=${encodeURIComponent(scan.value)}`;
  }
}
